import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import { getConcepts, createOrUpdateConcept } from './services/concepts';
import ClipLoader from "react-spinners/ClipLoader";
import { PencilIcon } from '@heroicons/react/20/solid';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import ResponsiveTable from '../../Shared/ResponsiveTable';
import NoAccesComponent from '../../Shared/NoAccesComponent';
import { ToastContainer, toast } from 'react-toastify';

export default class Concepts extends React.Component {



    BreadcrumbPages = [
        { name: 'Multas', href: '#', current: false },
        { name: 'Lista de Conceptos', href: '#', current: true },
    ]

    userCanEdit = false;

    columns = [
        {field:'concept', headerName: 'Concepto'},
        {field:'value', headerName: 'Valor'},
        {field:'art', headerName: 'Artículo'},
        {field:'numeral', headerName: 'Numeral'},
        {field:'literal', headerName: 'Literal'},
    ]

    renderActions = (row) => {
        return (
            <button 
                title='Ver detalle'
                onClick={() => {this.openUpdate(row)}}
                type="button"
                className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
            >
                <PencilIcon 
                    style={{padding:3}}
                    aria-hidden="true" className="h-5 w-5" />
            </button>
        )
    }

    constructor(props){
        super(props)
        this.state = {
            concepts: [],
            loading: true,
            conceptForm:false,
            concept:'',
            cost:0,
            art:0,
            numeral:0,
            literal:0,
            idConcept:0,
            loadingForm:false,
            canCreate: false,
            canEdit:false,
            canSee: false,
        }
    }

    componentDidMount = () => {
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        if(userType === 'ANALISTA') { 
        permissions = JSON.parse(permissions);
        let canCreate = false;
        let canEdit = false;
        let canSee = false;
        permissions[0].concepts.forEach(element => {
            if(element.name === 'see' && element.value === true){
                canSee = true;
            }
            if(element.name === 'create' && element.value === true){
                canCreate = true;
            }
            if(element.name === 'update' && element.value === true){
                canEdit = true;
            }
        });
        this.setState({canCreate:canCreate, canEdit:canEdit, canSee:canSee, loading:false});
        }else{
        this.setState({canCreate:true, canEdit:true, canSee:true, loading:false});
        }
        this.reloadConcepts();
    }

    reloadConcepts = () => {
        this.setState({loading:true})
        getConcepts({id:0})
            .then((result) => {
                const data = result.data.data.map((item) => {
                    item.pks = item.id;
                    return item;
                })
                this.setState({concepts:data, loading:false})
        }).catch((error) =>{ 
            this.setState({loading:false});
        })
    }

    verifyNumber(prop, value) {
        if(isNaN(value)){
            return;
        }else{
            this.setState({[prop]:value})
        }
    }

    endForm = () => {
        this.setState({loadingForm:true})
        if(this.state.concept === '' || this.state.cost === '') {
            toast('Concepto y Valor son obligatorios');
            this.setState({loadingForm:false})
            return;
        }
        if(isNaN(this.state.cost)) {
            toast('El Valor debe de ser un numero y mayor a 0');
            this.setState({loadingForm:false})
            return;
        }

        const body = {
            id:this.state.idConcept, 
            concept:this.state.concept, 
            value:parseInt(this.state.cost), 
            active:true,
            art:parseInt(this.state.art),
            numeral:parseInt(this.state.numeral),
            literal:parseInt(this.state.literal)
        };
        createOrUpdateConcept(body)
            .then((result) => {
                this.setState({conceptForm:false, concept:'', cost:'', idConcept:0, loadingForm:false});
                toast(result.data.message);
                this.reloadConcepts();
            })
            .catch((error) => {
                this.setState({loading:false, loadingForm:false})
                toast(error);
            })
    }

    cancell(){
        this.setState({conceptForm:false, concept:'', value:0, art:0, numeral:0, literal:0, cost:0})
    }

    newConceptForm(){
        return(
            <Dialog open={this.state.conceptForm} onClose={()=>console.log('closed')} className="relative z-10">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <DialogPanel
                                    transition
                                    className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                                >
                                    {
                                        !this.state.loadingForm ? 
                                            <div>
                                                <div>
                                                    <h2>Nuevo Concepto</h2>
                                                    <div>
                                                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                            Concepto
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                value={this.state.concept}
                                                                onChange={(e) => {this.setState({concept:e.target.value})}}
                                                                type="text"
                                                                placeholder=""
                                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                            Valor
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                value={this.state.cost}
                                                                onChange={(e) => {this.verifyNumber('cost', e.target.value)}}
                                                                type="text"
                                                                placeholder=""
                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                            Artículo
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                value={this.state.art}
                                                                onChange={(e) => {this.verifyNumber('art', e.target.value)}}
                                                                type="text"
                                                                placeholder=""
                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                            Numeral
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                value={this.state.numeral}
                                                                onChange={(e) => {this.verifyNumber('numeral', e.target.value)}}
                                                                type="text"
                                                                placeholder=""
                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                            Literal
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                value={this.state.literal}
                                                                onChange={(e) => {this.verifyNumber('literal', e.target.value)}}
                                                                type="text"
                                                                placeholder=""
                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}
                                                    className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                                    <button
                                                        type="button"
                                                        data-autofocus
                                                        onClick={() => {this.cancell()}}
                                                            className="mt-3 inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                                        >
                                                        Cancelar
                                                    </button>
                                                    <button
                                                        onClick={() => {this.endForm()}}
                                                        type="button"
                                                        data-autofocus
                                                        className='inline-flex items-center gap-x-1.5 rounded-md bg-indigo-900 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-900'
                                                    >
                                                        Guardar
                                                    </button>
                                                </div>
                                            </div>
                                        :
                                        <center>
                                            <ClipLoader
                                                color={'gray'}
                                                loading={true}
                                                size={50}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"/>
                                        </center>

                                    }
                                </DialogPanel>
                            </div>
                        </div>
                    </DialogBackdrop>
            </Dialog>
        )
    }

    openUpdate(concept){
        this.setState({
            concept:concept.concept, 
            cost:concept.value, 
            idConcept:concept.pks,
            art:concept.art,
            numeral:concept.numeral,
            literal:concept.literal,
            conceptForm:true});
    }

    renderConceptsList() {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                        <div class="w-full p-4">
                            <div class="w-full rounded overflow-hidden shadow-lg bg-white" style={{backgroundColor:'#f1f4ff'}}>
                                <div class="px-6 py-4">
                                    <p class="text-gray-700 text-base" style={{fontWeight:'bold'}}>
                                        En esta sección podrás crear y administrar los diferentes conceptos para las multas.
                                    </p>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                            {
                                this.state.canCreate ? 
                                    <button
                                        onClick={() => {this.setState({conceptForm:true})}}
                                        type="button"
                                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                    >
                                        NUEVO CONCEPTO
                                    </button>
                                    :
                                    null
                            }
                            
                        </div>
                    </div>
                    <div className="mt-8 flow-root">
                        <ResponsiveTable 
                            columns={this.columns} 
                            data={this.state.concepts}
                            renderActions={(row) => this.renderActions(row)}
                        />
                    </div>
                </div>
                {this.newConceptForm()}
            </div>
        )
    }

    render(){
        return( 
            <div>
                {
                    this.state.loading ? 
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center> : this.state.canSee ? this.renderConceptsList() : <NoAccesComponent/>
                }
                <ToastContainer position="top-center" hideProgressBar={true}/>
            </div>
        )
    }
}